import React from 'react';
import {withRouter} from 'react-router-dom';
import {Businesses} from 'api';
import {LoadingPage} from 'components/loading-page';
import {ShowIf} from 'components/utils';
import {DateTime} from 'components/UI/DateTime';
import {connect} from 'react-redux';
import {NoContent} from 'components/no-content';
import {numberFormat} from 'components/utils';

class ManageOrderProduct extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      isLoading: false,
      count: 0,
      skip: 0,
      limit: 10
    };
    this.loadMore = this.loadMore.bind(this);
  }

  componentDidMount() {
    if (this.props.myBusinesses) {
      this.setState({isLoading: true});
      Businesses.actions.countOrder.request({id: this.props.myBusinesses.id}).then((response) => {
        this.setState({count: response.data.count, isLoading: false});
        this.getList();
      }).catch((error) => {
        this.setState({isLoading: false});
      });
    }
  }

  getList() {
    this.setState({isLoading: true});
    let params = {
      id: this.props.myBusinesses.id,
      filter: {
        limit: this.state.limit,
        skip: this.state.skip,
        order: 'createdAt DESC'
      }
    };
    Businesses.actions.orders.request(params).then(response => {
      let orders = this.state.data;
      response.data.map((item, idx) => {
        orders.push(item);
      });
      this.setState({data: orders, isLoading: false});
    }).catch(() => {
      this.setState({isLoading: false});
    });
  }

  loadMore() {
    this.setState({skip: this.state.skip + 10}, () => {
      this.getList();
    });
  }

  showDetail(id) {
    this.props.history.push(`/my-business/orders/${id}`);
  }

  render() {
    return (
      <section className="order-history the-news list-complaint">
        <LoadingPage isShow={this.state.isLoading} />
        <ShowIf condition={this.state.data.length > 0}>
          <table className="complaint-table">
            <thead className="complaint-table-header">
              <tr>
                <th>Ngày đặt hàng</th>
                <th>Tổng tiền</th>
                <th>Trạng thái</th>
              </tr>
            </thead>
            <tbody className="complaint-table-list">
              {
                this.state.data.map((item, idx) => {
                  return (
                    <tr className="complaint-item" onClick={this.showDetail.bind(this, item.id)}>
                      <td><DateTime dateTime={item.createdAt} format="HH:mm MM/DD/YYYY" /></td>
                      <td>{numberFormat(item.amount, '.', '.', '.')} VNĐ</td>
                      <td>
                        <ShowIf condition={item.status === 1}>
                          <span className="label-success">Đã kết thúc</span>
                        </ShowIf>
                      </td>
                    </tr>
                  );
                })
              }
              <ShowIf condition={!this.state.isLoading && this.state.data.length > 0 && (this.state.skip + this.state.limit) < this.state.count}>
                <tr>
                  <td colSpan={3} className="btn-see-more-wrap">
                    <button className="btn-see-more" onClick={this.loadMore}>Xem Thêm</button>
                  </td>
                </tr>
              </ShowIf>
            </tbody>
          </table>
        </ShowIf>
        <ShowIf condition={!this.state.isLoading && this.state.data.length == 0}>
          <NoContent content='Không có đơn hàng nào'/>
        </ShowIf>

      </section>
    );
  }
}

const mapStateToProps = state => {
  return {
    myBusinesses: state.myBusinesses.mainBusiness
  };
};

export default withRouter(connect(mapStateToProps)(ManageOrderProduct));



// WEBPACK FOOTER //
// ./components/my-business/sub-view/manage-order/ManageOrderProduct.jsx